export const getSortData = (options) => {
  const { sortBy, sortDesc } = options

  const ordering = {}
  if (sortBy && sortBy.length) {
    for (const [index, item] of sortBy.entries()) {
      ordering[`ordering[${item}]`] = sortDesc[index] ? 'DESC' : 'ASC'
    }
  }

  return ordering
}


const ListSortUtil = {
  getSortData
}

export default ListSortUtil
